import { entitlements as AT } from './AT';
import { entitlements as CZ } from './CZ';
import { entitlements as HR } from './HR';
import { entitlements as HU } from './HU';
import { entitlements as RO } from './RO';
import { entitlements as SK } from './SK';
import { entitlements as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
